import { render } from "./origens-captacao.vue?vue&type=template&id=eac842d2"
import script from "./origens-captacao.vue?vue&type=script&lang=js"
export * from "./origens-captacao.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__